"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

var _reactSmoothCollapse = _interopRequireDefault(require("react-smooth-collapse"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Accordion =
/*#__PURE__*/
function (_Component) {
  _inherits(Accordion, _Component);

  function Accordion() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Accordion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Accordion)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      open: _this.props.customOpen !== undefined ? _this.props.customOpen : _this.props.defaultOpen
    });

    _defineProperty(_assertThisInitialized(_this), "onHeaderClick", function (event) {
      _this.setState(function (prevState) {
        return {
          open: !prevState.open
        };
      }, function () {
        return _this.props.onHeaderClick(event, _this.state.open);
      });
    });

    return _this;
  }

  _createClass(Accordion, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.open && !this.state.open) {
        this.props.onClose && this.props.onClose();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // eslint-disable-line camelcase
      if (this.props.customOpen !== nextProps.customOpen) {
        this.setState({
          open: nextProps.customOpen
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var open = this.state.open;
      var _this$props = this.props,
          title = _this$props.title,
          children = _this$props.children,
          style = _this$props.style,
          headerStyle = _this$props.headerStyle,
          bodyStyle = _this$props.bodyStyle,
          className = _this$props.className;
      return _react["default"].createElement("div", {
        className: "accordion".concat(open ? ' accordion-open ' : ' ').concat(className),
        style: style
      }, _react["default"].createElement("div", {
        className: "accordion-header",
        onClick: this.onHeaderClick,
        style: headerStyle
      }, _react["default"].createElement("div", {
        className: "accordion-arrow"
      }, _react["default"].createElement("i", {
        className: "fa fa-lg fa-angle-".concat(open ? 'down' : 'right')
      })), title), _react["default"].createElement(_reactSmoothCollapse["default"], {
        expanded: open
      }, _react["default"].createElement("div", {
        className: "accordion-body",
        style: bodyStyle
      }, children)));
    }
  }]);

  return Accordion;
}(_react.Component);

exports["default"] = Accordion;
Accordion.propTypes = {
  children: _propTypes["default"].node,
  title: _propTypes["default"].node,
  defaultOpen: _propTypes["default"].bool,
  customOpen: _propTypes["default"].bool,
  style: _reactStyleProptype["default"],
  headerStyle: _reactStyleProptype["default"],
  bodyStyle: _reactStyleProptype["default"],
  className: _propTypes["default"].string,
  onHeaderClick: _propTypes["default"].func,
  onClose: _propTypes["default"].func
};
Accordion.defaultProps = {
  defaultOpen: false,
  onHeaderClick: function onHeaderClick() {
    return undefined;
  },
  style: {},
  headerStyle: {},
  bodyStyle: {},
  className: ''
};